import React from "react";
import InputContainer from "./InputContainer";

const MyTextField = React.forwardRef((props, ref) => {
  const {
    label,
    name,
    placeholder,
    multiline,
    rows,
    error,
    size,
    onCustomChange,
    onFileChange,
    watch,
    mode,
    setValue,
    control,
    rules,
    ...otherProps
  } = props;
  return (
    <InputContainer {...props} label={label} error={error} size={size}>
      <input
        ref={ref}
        type="text"
        className="form-control"
        name={name}
        placeholder={placeholder}
        {...otherProps}
      />
    </InputContainer>
  );
});
export default MyTextField;
